const publicIconsPath = './assets/icons'

export const icons = {
  AL: `${publicIconsPath}/AL.png`,
  BA: `${publicIconsPath}/BA.png`,
  CE: `${publicIconsPath}/CE.png`,
  DF: `${publicIconsPath}/DF.png`,
  ES: `${publicIconsPath}/ES.png`,
  GO: `${publicIconsPath}/GO.png`,
  MG: `${publicIconsPath}/MG.png`,
  MT: `${publicIconsPath}/MT.png`,
  PA: `${publicIconsPath}/PA.png`,
  PB: `${publicIconsPath}/PB.png`,
  PE: `${publicIconsPath}/PE.png`,
  PI: `${publicIconsPath}/PI.png`,
  PR: `${publicIconsPath}/PR.png`,
  RJ: `${publicIconsPath}/RJ.png`,
  RN: `${publicIconsPath}/RN.png`,
  SP: `${publicIconsPath}/SP.png`,
  notFound: `${publicIconsPath}/error-404.png`
}
